// @spec TSK-STR-030

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/tasks/console/approvals')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.approvals'),
  }),
  component: RedirectToMyTasks,
});

function RedirectToMyTasks() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: '/tasks/my', replace: true });
  }, [navigate]);
  return null;
}
